import { CommonModule } from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BusLaneComponent } from './components/policies/bus-lane/bus-lane.component';
import { DisabledComponent } from './components/policies/disabled/disabled.component';
import { DispensationComponent } from './components/policies/dispensation/dispensation.component';
import { FirstContraventionComponent } from './components/policies/first-contravention/first-contravention.component';
import { EmergencyBadgeComponent } from './components/policies/emergency-badge/emergency-badge.component';
import { LoadingComponent } from './components/policies/loading/loading.component';
import { ParkingDiscComponent } from './components/policies/parking-disc/parking-disc.component';
import { PermitTemplateComponent } from './components/policies/permit/permit.component';
import { PayParkingComponent } from './components/policies/pay-parking/pay-parking.component';
import { ConcessionsPaymentComponent } from './components/policies/concessions-payment/concessions-payment.component';
import { ResidentComponent } from './components/policies/resident/resident.component';
import { VisitorComponent } from './components/policies/visitor/visitor.component';
import { PermitCustomComponent } from './components/policies/permit-custom/permit-custom.component';
import { ConcessionsOtherComponent } from './components/policies/concessions-other/concessions-other.component';
import { MetersComponent } from './components/policies/meters/meters.component';
import { ToiletComponent } from './components/policies/toilet/toilet.component';
import { TicketMachinesComponent } from './components/policies/ticket-machines/ticket-machines.component';
import { PaymentComponent } from './components/policies/payment/payment.component';
import { StaffComponent } from './components/policies/staff/staff.component';
import { StoppingPassengersComponent } from './components/policies/stopping-passengers/stopping-passengers.component';
import { TimescalesComponent } from './components/policies/timescales/timescales.component';
import { OtherComponent } from './components/policies/other/other.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    SharedModule,
    NgbModule,
  ],
  declarations: [
    BusLaneComponent,
    DisabledComponent,
    DispensationComponent,
    FirstContraventionComponent,
    EmergencyBadgeComponent,
    LoadingComponent,
    ParkingDiscComponent,
    PermitTemplateComponent,
    PayParkingComponent,
    ConcessionsPaymentComponent,
    ResidentComponent,
    VisitorComponent,
    PermitCustomComponent,
    ConcessionsOtherComponent,
    MetersComponent,
    ToiletComponent,
    TicketMachinesComponent,
    PaymentComponent,
    StaffComponent,
    StoppingPassengersComponent,
    TimescalesComponent,
    OtherComponent,
  ],
  exports: [
    BusLaneComponent,
    DisabledComponent,
    DispensationComponent,
    FirstContraventionComponent,
    EmergencyBadgeComponent,
    LoadingComponent,
    ParkingDiscComponent,
    PermitTemplateComponent,
    PayParkingComponent,
    ConcessionsPaymentComponent,
    ResidentComponent,
    VisitorComponent,
    PermitCustomComponent,
    ConcessionsOtherComponent,
    MetersComponent,
    ToiletComponent,
    TicketMachinesComponent,
    PaymentComponent,
    StaffComponent,
    StoppingPassengersComponent,
    TimescalesComponent,
    OtherComponent,
  ]
})
export class PoliciesModule { }
